module.exports = __webpack_public_path__ + "2effa4c86fc6c6f9c0949d3658c53068.svg";